module.exports = __webpack_public_path__ + "static/media/0.b9a0ce5d.jpg";